// extracted by css-extract-rspack-plugin
export default {"Link":"link-cell-module__Link__qc7nHe9"};